import React, {useState} from "react";
import withHeader from "../../hocs/withHeader";
import ContactForm from "./ContactForm";
import withFooter from "../../hocs/withFooter";


function ContactPage(){

    const [isMailSent,setMailSent] = useState(false);

    function emailSentHandler(){
        setMailSent(true)
    }

    return (
        <section className="contact">
            <div className="container">
                <h1>Contact</h1>
                <div className="contact__section">
                    <div className="contact__section__colLeft">
                        <div className="contact__section__title">Address</div>
                        <div className="contact__section__description contact__section__description--address">
                            Bucharest, Romania
                        </div>

                        <div className="contact__section__title">Social media</div>
                        <div className="contact__section__description contact__section__description--social">
                            Follow us on social media for useful info & updates!
                        </div>

                        <div className="contact__section__social">
                            <a href="https://www.facebook.com/bubblyPolls" target="_blank"><img src="./assets/img/contact/facebook-green.png" alt=""/></a>
                            <a href="https://www.linkedin.com/company/bubblypolls" target="_blank"><img src="./assets/img/contact/linkedin-green.png" alt=""/></a>
                            <a href="https://twitter.com/BubblyPolls" target="_blank"><img src="./assets/img/homepage/twitter.svg" alt=""/></a>
                        </div>
                    </div>
                    <div className="contact__section__colRight">
                        {!isMailSent ? <ContactForm emailSentHandler={emailSentHandler}></ContactForm> :
                            <div className="contact__section__title">THANK YOU FOR YOUR MESSAGE!
                                <br/>WE WILL GET BACK TO YOU SHORTLY </div>}

                    </div>
                </div>

            </div>
        </section>
    );
}
export default withFooter(withHeader(ContactPage));